import { runInAction } from 'mobx';
import { getInProgressItem } from '../../selectors/items/get-in-progress-item';
export const setInProgressItemInitialValidation = (isValid) => {
    const inProgressItem = getInProgressItem();
    if (!inProgressItem) {
        throw new Error('Cannot set in-progress order item validation state without an in-progress item.');
    }
    runInAction(() => {
        inProgressItem.initiallyDisplayAsValid = isValid;
    });
};
